import React from 'react';
import { Booking } from '../components/Booking';
import './BookingPage.css';

const BookingPage = () => {
  return (
    <div className="booking-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Book Your Slot</h1>
          <p className="page-description">
            Schedule a consultation or book your video editing service. We'll get back to you within 24 hours.
          </p>
        </div>
      </div>
      <Booking />
    </div>
  );
};

export default BookingPage;